import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { authRoutes, publicRoutes } from './feature-module/router/router.link';
import ReactGA from 'react-ga4';
import Home from './feature-module/mainMenu/home';
import PrivateRoute from "./route/PrivateRoute";
import PublicRoute from "./route/PublicRoute";
import ALLRoutes from "./feature-module/router/router";
import Register3 from "./feature-module/auth/register/register-3";
import Login2 from "./feature-module/auth/login/login-2";
import portalConfig from "./configurations/gil.config";
import TwoStepVerification3 from "./feature-module/auth/twoStepVerification/twoStepVerification-3";
import { setApplicationId, setLanguage , setFormLanguage, setUserDet, OnSignIn, setApplicationCount } from "./core/data/redux/authSlice";
import Error404 from "./feature-module/pages/error/error-404";
import ForgotPassword3 from "./feature-module/auth/forgotPassword/forgotPassword-3";
import ResetPasswordModal from "./feature-module/auth/resetPasswordSuccess/resetPassword";
import { all_routes } from "./feature-module/router/all_routes";
import useAuth from "./hooks/useAuth";
import { set } from "lodash";
import { getAllApplicationCounts, getSSODetails, getSsoToken, resisterAndLogin } from "./feature-module/auth/services/privateapicalling";
import { jwtDecode } from "jwt-decode";
import TraderPanelLogin from "./feature-module/auth/login/traderPanelLogin";
import AppSsoLogin from "./feature-module/auth/login/appSsoLogin";
import ApmcHomePage from "./core/common/homePage";
import AboutDetailsMore from "./core/common/homePage/components/aboutMore";
// import PaymentSuccess from "./feature-module/pages/license-registration-form/paymentstatus";

const allowedRoles = [
  "Trader_Registration",
  "Panel_Engineer_Registration",
  "Trader_Login",
  "Panel_Engineer_Login",
  "District_Registrar_Login",
  "APMC_Login",
  "Head_officer_Login",
  "GCA_Registration",
  "GCA_Login",
  "Sponsor_Login",
  "Sponsor_Registration"
];

   const LoginRole = [
  "Trader", "Panel Engineer" , "District" , "APMC" , "Head Office", "GCA", "Sponsor"
]

function App() {
  const [isLoginChecked , setIsLoginChecked] = useState(true);
  const [isSSODetailFetched , setIsSSODetailFetched] = useState(false);
  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state:any)=>state.auth.language);
    const formLanguage = useSelector((state:any)=>state.auth.formLanguage);
  const isAuthenticated = !!token;
  const dispatch = useDispatch();
  const roleIdentifier = useSelector(
    (state: any) => state.auth.userDetails?.Role?.Role_Identifier
  );
const MEASUREMENT_ID= process.env.REACT_APP_GA_MEASUREMENT_ID
  const { signOut } = useAuth();
    // const 
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const loginRole = params.get("role");
    const ssoid = params.get('SSOId');

  // const setlang="english";
  
  // dispatch(setLanguage(setlang));
  // dispatch(setFormLanguage("gujarati"));

  const {
    authenticateEntryDep,
    authenticateEntryTrader,
    authenticateEntryPannel,
    authenticateEntryGCA,
    authenticateSponsor,
    authenticateAccountant,
  } = portalConfig;

  // const removeAppId = 

  const navigate = useNavigate();
  const showLoginError = () => {
    alert("Your session is expired please login again");
  };
  let currExecTime = new Date().getTime();
  let finalTimeString = localStorage.getItem("tokenExpTime");
  let finalTime = Number(finalTimeString);
  let execTime = finalTime - currExecTime;

   
  const handleLogout = () => {
   
    if (token) {
      signOut();
      localStorage.removeItem("tokenExpTime");
      setTimeout(() => {
        showLoginError();
      }, 200);
    }
  };
  // const token = useSelector((state:any)=>state.auth.token);
  useEffect(() => {
    

    if (finalTime > 0) {
   
      let getData = setTimeout(() => {
        handleLogout();
      }, execTime);
      return () => clearTimeout(getData);
    }
  }, [execTime]);
  useEffect(() => {
     if (!MEASUREMENT_ID) {
    console.error("GA Measurement ID is missing");
    return;
  }
    ReactGA.initialize(MEASUREMENT_ID);
   
    ReactGA.send({
      hitType: 'pageview',
      page: '/',
      title: 'Home Page'
    });
  }, []);
  const handleAllCountsApplication = async ()=>{
    try{
      const getDAta = await getAllApplicationCounts(token);
   
      if(getDAta?.status == 500){
       
      }else if(getDAta?.success == true){
      dispatch(setApplicationCount(getDAta && getDAta?.data))  
      }else{
       
      }
    }catch(err){
  
    }
  }

  useEffect(()=>{
    if(token && roleIdentifier !== "SPO"){ //yashChangedCode
      handleAllCountsApplication()
    }
  },[token,location?.pathname])
 

  // handleAllCountsApplication()


  
  

  // ✅ Redirect ONLY if authenticated and NOT on login/register
  useEffect(() => {
    

    if (isAuthenticated) {

    
      const route =
        ["JC", "Dr", "COM", "DT", "SA", "SEC", "DY", "HOS" , "HJC","MBA","MBMD","SC","INSP"].includes(roleIdentifier)
          ? authenticateEntryDep
          : roleIdentifier === "Tr"
          ? authenticateEntryTrader
          : roleIdentifier === "Per"
          ? authenticateEntryPannel
          : roleIdentifier === "SPO"?
            authenticateSponsor
          : roleIdentifier === "ACCT"?
          authenticateAccountant:
          roleIdentifier === "GCA"?
          authenticateEntryGCA
          :  authenticateEntryGCA || "/";

      

      if ((location.pathname === "/login" || location.pathname === "/about-details" || location.pathname === "/user-verification" || location.pathname === "/myApplicationPanel" || location.pathname === "/ssoLogin/Trader" || location.pathname ===  "/ssoLogin/Panel_Engineer" ||location.pathname==="/ssoLogin/General_Commission_Agent") ) {
     
        setTimeout(() => navigate(route), 400);
      }
    }


    dispatch(setApplicationId(""));
    
  }, [isAuthenticated, location.pathname , isSSODetailFetched ,  roleIdentifier]);

  // ✅ Redirect to login only if accessing a protected route while not authenticated6

  useEffect(() => {
  dispatch(setLanguage("english"));
  dispatch(setFormLanguage("gujarati"));
}, []); // Empty array = run once on mount
  useEffect(() => {
   
    const firstPathSegment = location.pathname.includes("/")
  ? location.pathname.split("/")[1] || location.pathname
  : location.pathname;
    
   
    const searchParams = new URLSearchParams(location.search);
    const role = searchParams.get("role");
  
    

    if (!isAuthenticated) {
      if (["login", "register","forgot-password-3"].includes(firstPathSegment)) {
        // If on login or register page, check role
        if (!role || !allowedRoles.includes(role)) {
         
          navigate("/")
        }
      }
       else if (Object.values(all_routes).some(route => route.replace(/^\//, "").replace(/\/:.*/, "")  === firstPathSegment) && !["/login", "/register", "/","/user-verification","/ssoLogin/Trader" ,"/about-details",  "/ssoLogin/Panel_Engineer"].includes(location.pathname)) {  // old replace replace(/^\//, "")
       
        navigate("/", { replace: true });
      } 
     } else if(!isAuthenticated && ["/login", "/register","/about-details", "/","/user-verification","/ssoLogin/Trader" , "/ssoLogin/Panel_Engineer",, "/ssoLogin/General_Commission_Agent"].includes(location.pathname)){
  
      navigate(location.pathname)
    }
    else if(!isAuthenticated && Object.values(all_routes).some(route => route.replace(/^\//, "").replace(/\/:.*/, "") != firstPathSegment )){
      
      navigate("/error-404")
      //  navigate("/")
    }
    dispatch(setApplicationId(""));

  }, [isAuthenticated,roleIdentifier,location.pathname]);


  const handleFetchSsoDet = ()=>{
    setIsSSODetailFetched(true)
  }

  if (!isLoginChecked) {
  return (
    <div className="flex justify-center items-center h-screen">
      <i className="ion-load-a ion-spin text-4xl text-blue-600"></i>
    </div>
  );
}


  return (
    <Routes key={token ? "auth" : "guest"}>

      {/* <Route path="/" element={<Home />} /> */}
      <Route path="/" element={<ApmcHomePage />} />
      {/* <Route path="/:loginRole" element={<TraderPanelLogin handleFetchSsoDet={handleFetchSsoDet} />} /> */}
      <Route path="/register" element={<Register3 />} />
      <Route path="/about-details" element={<AboutDetailsMore />} />
      <Route path="/login" element={<Login2 />} />
      <Route path="/user-verification" element={<TwoStepVerification3 />} />
      <Route path="/error-404" element={< Error404 />} />
      <Route path="/forgot-password-3" element={ <ForgotPassword3 />} />
      <Route path="/resetPasswordModal" element={ <ResetPasswordModal email={""} username={""}refId={""} visible={false} onClose={function (): void {
        throw new Error("Function not implemented.");
       
      } } />} />


 
      <Route path="/*" element={<ALLRoutes />} />

       <Route path="/ssoLogin/:loginRole" element={<TraderPanelLogin handleFetchSsoDet={handleFetchSsoDet} />} />
       <Route path="/appSsoLogin/:role" element={<AppSsoLogin />} />

      <Route path='*'  element={< Error404 />} />
     

    </Routes>
    // <PaymentSuccess />
  );
}

export default App;
